import { FocusZoneMode } from '../../types';
import { IS_FOCUSABLE_ATTRIBUTE } from '../../FocusZone/focusUtilities';
import * as keyboardKey from 'keyboard-key';
import { FocusZoneDirection } from '../../FocusZone';
/**
 * @description
 * Sets the message to be a focusable element.
 * Adds a vertical circular focus zone navigation where a user navigates using a Tab key.
 * Adds a key action which prevents up and down arrow keys from navigating in FocusZone, we only want a Tab key to navigate.
 */
var chatMessageBehavior = function (props) {
    var _a;
    return ({
        attributes: {
            root: (_a = {},
                _a[IS_FOCUSABLE_ATTRIBUTE] = true,
                _a),
        },
        focusZone: {
            mode: FocusZoneMode.Embed,
            props: {
                handleTabKey: 1 /* all */,
                isCircularNavigation: true,
                direction: FocusZoneDirection.vertical,
            },
        },
        keyActions: {
            root: {
                // prevents default FocusZone behavior, in this case, prevents using arrow keys as navigation (we only want a Tab key to navigate)
                preventDefault: {
                    keyCombinations: [{ keyCode: keyboardKey.ArrowUp }, { keyCode: keyboardKey.ArrowDown }],
                },
            },
        },
    });
};
export default chatMessageBehavior;
